import styled from 'styled-components';
import { Flex } from '@/ui/Flex/Flex';
import { LinkedPlayerState } from './DisplayStatus/DisplayStatus';

export const StyledPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-y: hidden;
  padding: 32px;
  padding-bottom: 0px;
  gap: 16px;
  max-height: calc(100vh - 72px);
`;

export const StyledHeader = styled.div<{ disableFilters?: boolean }>`
  display: flex;
  justify-content: ${(props) =>
    props.disableFilters ? 'flex-end' : 'space-between'};
  width: 100%;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 75vw;
  max-width: 1200px;
  background-color: ${({ theme }) => theme.color('#F6F6F6')};
  padding: 24px;
  border-radius: 20px;
  overflow-y: hidden;
  margin-bottom: 24px;
  flex-grow: 1;
`;

export const StyledConfigsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
`;

export const StyledConfig = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.color('#FFFFFF')};
  padding: 32px;
  border-radius: 12px;
  position: relative;
  border: 1px solid rgba(55, 55, 55, 0.2);
  height: fit-content;
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  margin-top: auto;
`;

export const StyledStatsContainer = styled.div`
  display: grid;
  flex-grow: 1;
  grid-template-columns: minmax(0, 33%) 1px 33%;
  gap: 24px;
`;

export const StyledSubText = styled.p`
  font-size: 12px;
  color: #1b1a1f;
  opacity: 50%;
`;

export const StyledTabs = styled.ul`
  width: fit-content;
  list-style: none;
  display: flex;
`;

export const StyledItem = styled.li<{ active?: boolean }>`
  color: ${(props) => (props.active ? 'black' : '#767676')};
  border-bottom: 1px solid ${(props) => (props.active ? 'black' : '#B2B2B2')};
  padding-inline: 12px;
  padding-block: 4px;
  cursor: pointer;
  transition: all 0.1s ease;
  &:hover {
    opacity: 0.8;
  }
`;

export const StyledNoShelfWrapper = styled(Flex)`
  width: 100%;
  height: calc(100vh - 72px);
`;

export const StyledFlex = styled(Flex)`
  margin-right: 120px;
`;

export const StyledLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;

  svg {
    width: 48px;
    height: 48px;
    stroke: ${({ theme }) => theme.color('#676570')};
  }
`;

export const StyledCircle = styled.div<{
  status: LinkedPlayerState;
}>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) => {
    switch (props.status) {
      case LinkedPlayerState.ONLINE:
        return '#16BF00';
      case LinkedPlayerState.OFFLINE:
        return '#BF0000';
      case LinkedPlayerState.PARTIAL:
        return '#FFC48E';
      default:
        return '#A0A0A0';
    }
  }};
`;

export const StyledDivider = styled.div`
  height: 100%;
  width: 1px;
  background-color: ${({ theme }) => theme.color('#E0E0E0')};
`;
